import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";

import { GridColumn, GridRow } from "arv-reactcomponents";

import { ORDERDETAILS } from "npmlinks-constants";

const { ORDER_DETAILS: { DELIVERY_STATUS_TITLE } } = ORDERDETAILS;

class ConsignmentDelivery extends PureComponent {
  static getDeliveryMap(deliveryState) {
    const [title] = Object.keys(deliveryState);
    const { statusText, date, state } = deliveryState && deliveryState[title];
    const disabled = state === 0 ? "nw-disabled" : "";
    const iconDisabled = state === 1 ? "nwc-hide" : "";
    return {
      title,
      statusText,
      date,
      state,
      disabled,
      iconDisabled,
    };
  }
  constructor() {
    super();
    this.deliveryMap = this.deliveryMap.bind(this);
  }
  deliveryMap(deliveryArray) {
    return (
      deliveryArray &&
      deliveryArray.map((deliveryState, index) => {
        const {
          title,
          statusText,
          date,
          state,
          disabled,
          iconDisabled,
        } = ConsignmentDelivery.getDeliveryMap(deliveryState);
        return (
          <GridColumn className="nw-consignment-status" key={index}>
            <div className="nw-consignment-statustitle">{title}</div>
            <div
              className={`nw-consignment-checkicon nw-consignment-check ${disabled}`}
            >
              <i className={`icomoon-check ${iconDisabled}`} />
            </div>
            <div className="nw-consignment-statustext">{statusText}</div>
            <div className="nw-consignment-status-date">{date}</div>
          </GridColumn>
        );
      })
    );
  }
  render() {
    const {
      itemDeliveryStates,
      itemReturnStatesDetails,
      itemDeliveryDateInfo,
    } = this.props;
    let deliveryStates = [];
    if (itemDeliveryStates && itemDeliveryStates.length > 0) {
      deliveryStates = this.deliveryMap(itemDeliveryStates);
    } else if (itemReturnStatesDetails && itemReturnStatesDetails.length > 0) {
      deliveryStates = this.deliveryMap(itemReturnStatesDetails);
    }
    return (
      <Fragment>
        <div className="nw-consignment-subtitle nw-consignment-delivery">
          {DELIVERY_STATUS_TITLE}
        </div>
        <GridRow className="nw-consignment-deliverystatus">
          {deliveryStates}
        </GridRow>
        <div className="nw-consignment-estimate">{itemDeliveryDateInfo}</div>
      </Fragment>
    );
  }
}

ConsignmentDelivery.defaultProps = {
  itemDeliveryStates: [],
  itemReturnStatesDetails: [],
  itemDeliveryDateInfo: "",
};

ConsignmentDelivery.propTypes = {
  itemDeliveryStates: PropTypes.arrayOf(PropTypes.object),
  itemDeliveryDateInfo: PropTypes.string,
  itemReturnStatesDetails: PropTypes.arrayOf(PropTypes.object),
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ConsignmentDelivery,
  component: ConsignmentDelivery,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/ConsignmentDelivery/index.js